import React from 'react';

const Center = ({ children }) => {
    return (
        <div className="clx-step__center" style={{ textAlign: 'center' }}>
            {children}
        </div>
    );
};

export default Center;
